import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { provideDefaultConfigFactory, provideDefaultConfig } from '@spartacus/core';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import { CommonConfiguratorModule } from '@spartacus/product-configurator/common';
import { PageLayoutComponent, CmsPageGuard } from '@spartacus/storefront';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const PRODUCT_CONFIGURATOR_TEXTFIELD_FEATURE = 'productConfiguratorTextfield';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const cmsComponents = ['TextfieldConfigurationForm'];
// TODO: Inline this factory when we start releasing Ivy compiled libraries
function defaultProductConfiguratorTextfieldComponentsConfig() {
  const config = {
    featureModules: {
      [PRODUCT_CONFIGURATOR_TEXTFIELD_FEATURE]: {
        cmsComponents
      }
    }
  };
  return config;
}
/**
 * Contains feature module configuration
 */
let TextfieldConfiguratorRootFeatureModule = /*#__PURE__*/(() => {
  class TextfieldConfiguratorRootFeatureModule {
    static {
      this.ɵfac = function TextfieldConfiguratorRootFeatureModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextfieldConfiguratorRootFeatureModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TextfieldConfiguratorRootFeatureModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultProductConfiguratorTextfieldComponentsConfig)]
      });
    }
  }
  return TextfieldConfiguratorRootFeatureModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultTextfieldRoutingConfig = {
  routing: {
    routes: {
      configureTEXTFIELD: {
        paths: ['configure/textfield/:ownerType/entityKey/:entityKey']
      },
      configureOverviewTEXTFIELD: {
        paths: ['configure-overview/textfield/:ownerType/entityKey/:entityKey/displayOnly/:displayOnly', 'configure-overview/textfield/:ownerType/entityKey/:entityKey']
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides the default cx routing configuration for the textfield configurator
 */
let TextfieldConfiguratorRoutingModule = /*#__PURE__*/(() => {
  class TextfieldConfiguratorRoutingModule {
    static forRoot() {
      return {
        ngModule: TextfieldConfiguratorRoutingModule,
        providers: [provideDefaultConfig(defaultTextfieldRoutingConfig)]
      };
    }
    static {
      this.ɵfac = function TextfieldConfiguratorRoutingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextfieldConfiguratorRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TextfieldConfiguratorRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return TextfieldConfiguratorRoutingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Exposes the root modules that we need to statically load. Contains page mappings
 */
let TextfieldConfiguratorRootModule = /*#__PURE__*/(() => {
  class TextfieldConfiguratorRootModule {
    static forRoot() {
      return {
        ngModule: TextfieldConfiguratorRootModule
      };
    }
    static {
      this.ɵfac = function TextfieldConfiguratorRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextfieldConfiguratorRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TextfieldConfiguratorRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          layoutSlots: {
            TextfieldConfigurationTemplate: {
              slots: ['TextfieldConfigContent']
            }
          }
        })],
        imports: [CommonModule, CommonConfiguratorModule, TextfieldConfiguratorRootFeatureModule, TextfieldConfiguratorRoutingModule.forRoot(), RouterModule.forChild([{
          // We can neither omit the path nor set to undefined
          // @ts-ignore
          path: null,
          component: PageLayoutComponent,
          data: {
            cxRoute: 'configureTEXTFIELD'
          },
          canActivate: [CmsPageGuard]
        }, {
          // We can neither omit the path nor set to undefined
          // @ts-ignore
          path: null,
          component: PageLayoutComponent,
          data: {
            cxRoute: 'configureOverviewTEXTFIELD'
          },
          canActivate: [CmsPageGuard]
        }])]
      });
    }
  }
  return TextfieldConfiguratorRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PRODUCT_CONFIGURATOR_TEXTFIELD_FEATURE, TextfieldConfiguratorRootFeatureModule, TextfieldConfiguratorRootModule, TextfieldConfiguratorRoutingModule, defaultProductConfiguratorTextfieldComponentsConfig };
